// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
'use client';
import React from 'react';
import { getAnalyticsMetadataAttribute } from '@cloudscape-design/component-toolkit/internal/analytics-metadata';
import useBaseComponent from '../internal/hooks/use-base-component';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import InternalToken from './internal';
import analyticsSelectors from './analytics-metadata/styles.css.js';
export default function Token(props) {
    const baseComponentProps = useBaseComponent('Token');
    const componentAnalyticsMetadata = {
        name: 'awsui.Token',
        label: `.${analyticsSelectors.token}`,
    };
    return (React.createElement(InternalToken, { ...props, ...baseComponentProps, ...getAnalyticsMetadataAttribute({ component: componentAnalyticsMetadata }) }));
}
applyDisplayName(Token, 'Token');
//# sourceMappingURL=index.js.map